import { layout } from 'thewest/App.routing'

export const foodAndDrinkSegment = layout.nestedComposition({
    type: 'janus',
    props: {
        stretchColumns: true,
        verticalSpacing: 'xl',
    },
    contentAreas: {
        left: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'food',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Food',
                        headingUrl: '/lifestyle/food',
                    },
                    verticalSpacing: 'md',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
        right: [
            layout.component({
                type: 'lima',
                props: {
                    dataDefinitionArgs: {
                        type: 'curation',
                        name: 'drink',
                        offset: 0,
                        pageSize: 4,
                    },
                    sectionHeader: {
                        heading: 'Drink',
                        headingUrl: '/lifestyle/drink',
                    },
                    verticalSpacing: 'md',
                    fixedRatios: ['16:9'],
                    finalColumns: 2,
                    stretchSelf: true,
                    cardLayout: [
                        ['teaserWithBackground'],
                        [
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                            {
                                type: 'landscape',
                                format: 'landscape-paddingNoKicker',
                            },
                        ],
                    ],
                    cardOrientation: {
                        type: 'Landscape-Portrait',
                    },
                },
            }),
        ],
    },
})
